import { render } from "./DrawingEditPage.vue?vue&type=template&id=ee5bfc0e"
import script from "./DrawingEditPage.vue?vue&type=script&lang=js"
export * from "./DrawingEditPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__